import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { ReactNode } from 'react'

interface GovUKButtonGroupProps {
  children: ReactNode
}

export function GovUKButtonGroup({ children }: GovUKButtonGroupProps) {
  return <div className="govuk-button-group">{children}</div>
}
